// Library Class
import * as $ from 'jquery';
import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy, HostListener } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ToastrService } from 'ngx-toastr';
import { Subscription, forkJoin } from 'rxjs';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { DatePipe } from '@angular/common';
// Class
import { MasterConstants } from '../../../../common/constants/master-constants';
import { SRAOrdersLandingFilterVM } from '../../../../models/SRAOrders/SRAOrdersLandingFilterVM';
import { SraOrdersService } from '../../../../services/cpp/sra-orders.service';
import { LoaderService } from '../../../../services/infrastructure/loader.service';
import { Router } from '@angular/router';

// Service Class
import { LocalStorageService } from '../../../../services/infrastructure/local-storage.service';
import { CppService } from '../../../../services/cpp/cpp.service';
import { CommonService } from './../../../../services/common/common.service';
import { ConfirmDialogComponent } from '../../../../common/components/confirm-dialog/confirm-dialog.component';
import { CPPOrderSummaryVM } from '../../../../models/CPP/CPPOrderSummaryVM';
import { LolLoggerService } from '../../../../common/shared/lol-logger.service';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-sra-orders-landing',
  templateUrl: './sra-orders-landing.component.html',
  styleUrl: './sra-orders-landing.component.scss'
})
export class SraOrdersLandingComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('openRequestTable', { read: MatSort }) openRequestSort: MatSort;
  @ViewChild('openRequestPaginator', { read: MatPaginator }) openRequestPaginator: MatPaginator;
  @ViewChild('placedRequestTable', { read: MatSort }) placedRequestSort: MatSort;
  @ViewChild('placedRequestPaginator', { read: MatPaginator }) placedRequestPaginator: MatPaginator;
  tabNode = false;
  orderPdf: CPPOrderSummaryVM = new CPPOrderSummaryVM();
  productOpenFilters: any;
  openFilter: SRAOrdersLandingFilterVM = new SRAOrdersLandingFilterVM();
  productPlaceFilters: any;
  placeFilter: SRAOrdersLandingFilterVM = new SRAOrdersLandingFilterVM();
  openFilterValueList = new Array();
  placeFilterValueList = new Array();
  openSelectedValue: string = 'Status';
  placeSelectedValue: string = 'Status';
  isSubscriptionAccess = false;
  isRedirectedFrom = false;
  isBulkItemAvailable = false;
  isShowPlaceOrderTab = true;
  isPackagedItemAvailable = false;
  totalOrderCost = 0;
  totalNumbersOfOrder = 0;
  totalnumbersOfProduct = 0;
  deliverToAccountdetails: any = {};
  soldToAccountdetails: any = {};
  pdfDataObject: any;
  disclaimerMessage: string;
  dynamicDisclaimerMessage: string;
  selectedValue: string = 'Status';
  filterValueList = new Array();
  searchTypeList: string[] = ['Customer PO#', 'Account Name', 'Account Number', 'Product Name', 'Item Number', 'Status', 'Crop Year', 'Request ID'];
  searchPlaceTypeList: string[] = ['Customer PO#', 'Account Name', 'Account Number', 'Product Name', 'Item Number', 'Status', 'Crop Year','Order ID'];
  openRequestColumns: string[] = ['returnRequestID', 'customerPO', 'shipToAccount', 'deliverToAccount', 'requestDate', 'status', 'contextMenu'];
  placedRequestColumns: string[] = ['webOrderNumber', 'purchaseOrderNumber', 'accountName', 'accountNumber', 'orderCreateDate', 'status', 'contextMenu'];
  productFilters: any;
  filter: SRAOrdersLandingFilterVM = new SRAOrdersLandingFilterVM();
  selectedTabIndex = 0;
  openRequestDataSource: MatTableDataSource<any>;
  placedRequestDataSource: MatTableDataSource<any>;
  openRequestList: any = [];
  placedRequestList: any = [];
  itemList: any = [];
  cropYearList: any = [];

  statusList: any = [{ 'id': 'O', 'value': 'OPEN' }, { 'id': 'C', 'value': 'COMPLETED' }];
  processingStatusList: any = [
    { 'id': 'ORDER CREATED', 'value': 'ORDER CREATED' },
    { 'id': 'SUBMITTED', 'value': 'SUBMITTED' },
    { 'id': 'CANCELLED', 'value': 'CANCELLED' },
    { 'id': 'ERROR', 'value': 'ERROR' }
  ];
  masterConstants = MasterConstants;
  private subscription = new Subscription();
  userMenuAccessList: any;
  readOnlyAccess: boolean = false;
  hasSraEditAccess: boolean = false;
  hasSecurityApproveAccess: boolean = false;
  hasSecurityApproveReadOnlyAccess: boolean = false;
  hasRequestAccesse: boolean = false;
  hasReviewAccess: boolean = false;
  hasReviewApproveAccess: boolean = false;
  headerCompany = MasterConstants.US_COMPANYCODE;
  cppProductItemsDataSource2: any[];
  constructor(
    private router: Router,
    private cppService: CppService,
    private sraOrdersService: SraOrdersService,
    private loaderService: LoaderService,
    private toastrService: ToastrService,
    private localStorageService: LocalStorageService,
    private commonService: CommonService,
    private matDialog: MatDialog,
    private datePipe: DatePipe,
  ) {
  }

  ngOnInit(): void {
    const evolveAccessData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
    if (evolveAccessData) {
      const sessionData = evolveAccessData.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
      this.userMenuAccessList = sessionData.userMenuAccessList;
      this.isSubscriptionAccess = sessionData.isSubscriptionAccess;
      if (this.userMenuAccessList && this.userMenuAccessList.length > 0) {
        this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.SRA_ORDERS, MasterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList);
        if (this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.SRA_APPROVERS, MasterConstants.USER_ACCESS.EDIT_FULL, this.userMenuAccessList)) {
          this.hasSecurityApproveAccess = true;
        }
        else {
          this.hasReviewAccess = true;
        }

        if (this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.SRA_ORDERS, MasterConstants.USER_ACCESS.EDIT_FULL, this.userMenuAccessList)) {
          this.hasSraEditAccess = true;
        }
      }
    }
    this.subscription.add(this.commonService.currentTabIndex.subscribe(val => {
      this.selectedTabIndex = val;
    }));

    this.disclaimerMessage = 'Prices subject to change without notice. All Products(except inoculants) priced date of shipment & prices refresh daily';
    this.GetDisclaimerMessage();
    this.getRequestAccess();
    this.clearAllFilter(true);
    this.getSroMasterData();
    this.setAccSummaryTableHeight();
  }

  getSroMasterData() {
    this.loaderService.setLoaderStatus(true);
    const forkJoinAPIs = [];
    forkJoinAPIs.push(this.sraOrdersService.getItemNumberList());
    forkJoinAPIs.push(this.sraOrdersService.getSroCropYearList());
    this.subscription.add(forkJoin(forkJoinAPIs).subscribe((result: any[]) => {
      if (result) {
        this.itemList = result[0];
        this.cropYearList = result[1];
        this.GetSraOrdersByRetainedFilters();
        if (this.selectedTabIndex === 1) {
          this.getSraPlacedOrderList();
        }
        else {
          this.checkPlaceOrderStatus();
          this.applyDefaultFilter();
          this.getSRAOrderRequestList();
        }
      }
      this.loaderService.setLoaderStatus(false);
    }, error => { this.loaderService.setLoaderStatus(false); }));
  }

  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setAccSummaryTableHeight();
  }

  GetDisclaimerMessage() {
    this.subscription.add(this.sraOrdersService.GetDisclaimerMessage().subscribe((result: any) => {
      if (result) {
        this.dynamicDisclaimerMessage = result.message;
      }
    }, error => LolLoggerService.error(error)));
  }
  // Tab changed
  tabChanged = (tabChangeEvent: MatTabChangeEvent): void => {
    if (this.selectedTabIndex === 0 && this.selectedTabIndex !== tabChangeEvent.index) {
      this.productOpenFilters = this.productFilters;
      this.openFilter = this.filter;
      this.openFilterValueList = this.filterValueList;
      this.openSelectedValue = this.selectedValue

      this.productFilters = this.productPlaceFilters;
      this.filter = this.placeFilter;
      this.filterValueList = this.placeFilterValueList;
      this.selectedValue = this.placeSelectedValue;
    }
    else if (this.selectedTabIndex === 1 && this.selectedTabIndex !== tabChangeEvent.index) {

      this.productPlaceFilters = this.productFilters;
      this.placeFilter = this.filter;
      this.placeFilterValueList = this.filterValueList;
      this.placeSelectedValue = this.selectedValue

      this.productFilters = this.productOpenFilters;
      this.filter = this.openFilter;
      this.filterValueList = this.openFilterValueList;
      this.selectedValue = this.openSelectedValue;

    }
    this.selectedTabIndex = tabChangeEvent.index;
    this.getSearchData();
    this.setAccSummaryTableHeight();
  };

  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setAccSummaryTableHeight();
  }


  // Reset Page Filter
  resetPageFilter(isFirstLoad: Boolean) {
    this.productFilters = {
      'ProductName': null,
      'ItemNumber': [],
      'AccountName': null,
      'TxtAccountNo': null,
      'RequestID': null,
      'WebOrderNumber': null,
      'Status': null,
      'CropYear':null,
      'CustomerPO': null,
    };

    this.filter = {
      'productName': null,
      'itemNumber': null,
      'accountName': null,
      'accountNumber': null,
      'requestID': null,
      'status': null,
      'cropYear': null,
      'customerPO': null,
      'webOrderNumber': null
    };
    if (isFirstLoad) {
      this.productOpenFilters = JSON.parse(JSON.stringify(this.productFilters));
      this.openFilter = JSON.parse(JSON.stringify(this.filter));
      this.openFilterValueList = new Array();
      this.openSelectedValue = 'Status';
      this.productPlaceFilters = JSON.parse(JSON.stringify(this.productFilters));
      this.placeFilter = JSON.parse(JSON.stringify(this.filter));
      this.placeFilterValueList = new Array();
      this.placeSelectedValue = 'Status';
      this.filter.status = isFirstLoad && this.selectedTabIndex == 0 ? 'O' : null;
      this.openFilter.status = isFirstLoad && this.selectedTabIndex == 0 ? 'O' : null;
    } else {
      if (this.selectedTabIndex == 0) {
        this.productOpenFilters = JSON.parse(JSON.stringify(this.productFilters));
        this.openFilter = JSON.parse(JSON.stringify(this.filter));
        this.openFilterValueList = new Array();
        this.openSelectedValue = 'Status';
      } else {
        this.productPlaceFilters = JSON.parse(JSON.stringify(this.productFilters));
        this.placeFilter = JSON.parse(JSON.stringify(this.filter));
        this.placeFilterValueList = new Array();
        this.placeSelectedValue = 'Status';
      }
    }

  }

  // View Order detail and retain filters.
  viewOrderDetail(obj: any, isSplitView: boolean, tab: string) {
    if (isSplitView) {
      this.cppService.webOrderNumberAndSplitId = obj.webOrderNumber + '~' + obj.splitId + '~' + tab + '~CPPLanding';
    } else {
      this.cppService.webOrderNumberAndSplitId = obj.webOrderNumber + '~' + 0 + '~' + tab + '~CPPLanding';
    }
    // save filters in localstorage for retrieving them on navigating back.
    this.cppService.redirectFromSra = 'sra-orders';
    // save filters in localstorage for retrieving them on navigating back.
    this.saveFilters();
    this.router.navigate(['/sra/sra-order-summary']);
  }

  GetSraOrdersByRetainedFilters() {

    const productOpenFilters = this.localStorageService.get('productOpenFilters');
    const openFilter = this.localStorageService.get('openFilter');
    const openFilterValueList = this.localStorageService.get('openFilterValueList');
    const openSelectedValue = this.localStorageService.get('openSelectedValue');

    const productPlaceFilters = this.localStorageService.get('productPlaceFilters');
    const placeFilter = this.localStorageService.get('placeFilter');
    const placeSelectedValue = this.localStorageService.get('placeSelectedValue');
    const placeFilterValueList = this.localStorageService.get('placeFilterValueList');

    if (productOpenFilters && openFilter && openFilterValueList && openSelectedValue && this.selectedTabIndex === 0) {
      this.productOpenFilters = JSON.parse(productOpenFilters);
      this.openFilter = JSON.parse(openFilter);
      this.openFilterValueList = JSON.parse(openFilterValueList);
      this.openSelectedValue = JSON.parse(openSelectedValue);

      this.productFilters = JSON.parse(productOpenFilters);
      this.filter = JSON.parse(openFilter);
      this.filterValueList = JSON.parse(openFilterValueList);
      this.selectedValue = JSON.parse(openSelectedValue);

      this.productPlaceFilters = JSON.parse(productPlaceFilters);
      this.placeFilter = JSON.parse(placeFilter);
      this.placeSelectedValue = JSON.parse(placeSelectedValue);
      this.placeFilterValueList = JSON.parse(placeFilterValueList);
      //this.retainFilter(null, ' ');
    }

    if (productPlaceFilters && placeFilter && placeSelectedValue && placeFilterValueList && this.selectedTabIndex === 1) {
      this.productPlaceFilters = JSON.parse(productPlaceFilters);
      this.placeFilter = JSON.parse(placeFilter);
      this.placeSelectedValue = JSON.parse(placeSelectedValue);
      this.placeFilterValueList = JSON.parse(placeFilterValueList);

      this.productFilters = JSON.parse(productPlaceFilters);
      this.filter = JSON.parse(placeFilter);
      this.selectedValue = JSON.parse(placeSelectedValue);
      this.filterValueList = JSON.parse(placeFilterValueList);

      this.productOpenFilters = JSON.parse(productOpenFilters);
      this.openFilter = JSON.parse(openFilter);
      this.openFilterValueList = JSON.parse(openFilterValueList);
      this.openSelectedValue = JSON.parse(openSelectedValue);

      //this.retainFilter(null, ' ');
    }
    this.localStorageService.remove('productOpenFilters');
    this.localStorageService.remove('openFilter');
    this.localStorageService.remove('openFilterValueList');
    this.localStorageService.remove('openSelectedValue');

    this.localStorageService.remove('productPlaceFilters');
    this.localStorageService.remove('placeFilter');
    this.localStorageService.remove('placeSelectedValue');
    this.localStorageService.remove('placeFilterValueList');
  }
  // Email order detail
  emailOrderDetail(obj: any) {
    this.tabNode = this.tabNode ? false : true;
    const data = this.isSubscriptionAccess ? { title: 'Send Email', tabNode: this.tabNode, dialogType: 'nonSubscriberEmail' } : { email: obj.emailId, title: 'Send Email', tabNode: this.tabNode, dialogType: 'email' };
    const emailDialog = this.matDialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '480px',
      data: data
    });

    this.subscription.add(emailDialog.afterClosed().subscribe(emailIds => {
      // If user selected Yes
      if (emailIds) {
        const data = {
          WebOrderNumber: obj.webOrderNumber,
          EmailIds: emailIds
        };
        this.subscription.add(this.cppService.sendCPPOrderConfirmationEmail(data).subscribe(result => {
          if (result) { this.toastrService.success('Email sent'); }
        }));
      }
      this.tabNode = false;
    }));
  }


  // Generate Pdf report
  generatePdf(order: any) {
    if (order.webOrderNumber) {
      this.loaderService.setLoaderStatus(true);
      const self = this;
      this.subscription.add(this.cppService.getOrderSummaryDetails(order.webOrderNumber).subscribe((result: CPPOrderSummaryVM) => {
        if (result) {
          if (result !== undefined && result.splitDetails.length > 0) {
            this.cppProductItemsDataSource2 = result.splitDetails;
            this.cppProductItemsDataSource2.forEach(x => {
              x.productDetail.forEach(prod => {
                if (prod.bulkPackaged == 'bulk' || prod.bulkPackaged == 'BULK') {
                  this.isBulkItemAvailable = true;
                }
                else if (prod.bulkPackaged == "packaged" || prod.bulkPackaged == "PACKAGED") {
                  this.isPackagedItemAvailable = true;
                }
              });
            });
            self.orderPdf = result;
            this.pdfDataObject = result;
            this.totalNumbersOfOrder = result.splitDetails.length;
            result.splitDetails.forEach(x => {
              this.totalnumbersOfProduct += x.productDetail.length;
              x.productDetail.forEach(prod => {
                this.totalOrderCost += prod.totalPrice;
              });
            });
            const documentDefinition = this.getDocumentDefinition();
            pdfMake.createPdf(documentDefinition).download('CPP_Order_' + order.webOrderNumber + '_' + this.commonService.GetTimeForFileName() + '.pdf');
          } else {
            this.toastrService.error('No data available for WebOrderNumber #' + order.webOrderNumber);
          }
          this.loaderService.setLoaderStatus(false);
        }
      }, error => {
        this.loaderService.setLoaderStatus(false);
      }));
    }
  }

  // Get the details filled for variables above and below the table in PDF
  getDocumentDefinition() {
    const dt = new Date();
    const currDate = this.datePipe.transform(dt, 'MM/dd/yyyy');
    // const orderCreateDate = new Date(this.pdfDataObject.createdOn);
    const orderCreateDate = this.pdfDataObject.createdOnString;

    if (this.pdfDataObject.deliverToDetail) {
      this.deliverToAccountdetails.AccountNumber = this.pdfDataObject.deliverToDetail.accountNo;
      this.deliverToAccountdetails.AccountName = this.pdfDataObject.deliverToDetail.accountName;
      this.deliverToAccountdetails.Address1 = this.pdfDataObject.deliverToDetail.address1;
      this.deliverToAccountdetails.AccountCity = this.pdfDataObject.deliverToDetail.city;
      this.deliverToAccountdetails.AccountState = this.pdfDataObject.deliverToDetail.state;
      this.deliverToAccountdetails.AccountZipCode = this.pdfDataObject.deliverToDetail.zipCode;
    }

    // this.soldToAccountdetails
    if (this.pdfDataObject.soldToDetail) {
      this.soldToAccountdetails.AccountNumber = this.pdfDataObject.soldToDetail.accountNo;
      this.soldToAccountdetails.AccountName = this.pdfDataObject.soldToDetail.accountName;
      this.soldToAccountdetails.Address1 = this.pdfDataObject.soldToDetail.address1;
      this.soldToAccountdetails.Address2 = this.pdfDataObject.soldToDetail.address2.replace('<br>', '');
      this.soldToAccountdetails.AccountCity = this.pdfDataObject.soldToDetail.city;
      this.soldToAccountdetails.AccountState = this.pdfDataObject.soldToDetail.state;
      this.soldToAccountdetails.AccountZipCode = this.pdfDataObject.soldToDetail.zipCode;
    }

    let displayWith = [];
    let columnList = [];
    let valueList = [];
    let bulkdetailsheader;

    // ShipTo Account available
    if (!this.deliverToAccountdetails.AccountName && !this.soldToAccountdetails.AccountName) {
      displayWith = ['100%'];
      columnList = [{ text: 'SHIP TO: ' + this.pdfDataObject.accountNumber, bold: true }];
      valueList = [
        this.pdfDataObject.accountName + ' \n' +
        this.pdfDataObject.accountAddress1 + ' \n' +
        this.pdfDataObject.accountCity + ', ' + this.pdfDataObject.accountState + ' ' + this.pdfDataObject.accountZipCode,
      ];
    }
    // ShipTo & DeliverTo  Account available
    else if (this.deliverToAccountdetails.AccountName && !this.soldToAccountdetails.AccountName) {
      displayWith = ['50%', '50%'];
      columnList = [{ text: 'SHIP TO: ' + this.pdfDataObject.accountNumber, bold: true }, { text: 'DELIVER TO: ' + this.deliverToAccountdetails.AccountNumber, bold: true }];
      valueList = [

        this.pdfDataObject.accountName + ' \n' +
        this.pdfDataObject.accountAddress1 + ' \n' +
        this.pdfDataObject.accountCity + ', ' + this.pdfDataObject.accountState + ' ' + this.pdfDataObject.accountZipCode,

        this.deliverToAccountdetails.AccountName + ' \n' +
        this.deliverToAccountdetails.Address1 + ' \n' +
        this.deliverToAccountdetails.AccountCity + ', ' + this.deliverToAccountdetails.AccountState + ' ' + this.deliverToAccountdetails.AccountZipCode + ' \n',
      ];
    }
    // ShipTo & SoldTo Account available
    else if (!this.deliverToAccountdetails.AccountName && this.soldToAccountdetails.AccountName) {
      displayWith = ['50%', '50%'];
      columnList = [{ text: 'SOLD TO: ' + this.soldToAccountdetails.AccountNumber, bold: true }, { text: 'SHIP TO: ' + this.pdfDataObject.accountNumber, bold: true }];
      valueList = [
        this.soldToAccountdetails.AccountName + ' \n' +
        this.soldToAccountdetails.Address1 + ' \n' +
        (this.soldToAccountdetails.Address2 == '' ? '' : this.soldToAccountdetails.Address2 + ' \n') +
        this.soldToAccountdetails.AccountCity + ', ' + this.soldToAccountdetails.AccountState + ' ' + this.soldToAccountdetails.AccountZipCode + ' \n',

        this.pdfDataObject.accountName + ' \n' +
        this.pdfDataObject.accountAddress1 + ' \n' +
        this.pdfDataObject.accountCity + ', ' + this.pdfDataObject.accountState + ' ' + this.pdfDataObject.accountZipCode,
      ];
    }
    // ShipTo, SoldTo & DeliverTo Account available
    else {
      displayWith = ['33%', '33%', '33%'];
      columnList = [{ text: 'SOLD TO: ' + this.soldToAccountdetails.AccountNumber, bold: true }, { text: 'SHIP TO: ' + this.pdfDataObject.accountNumber, bold: true }, { text: 'DELIVER TO: ' + this.deliverToAccountdetails.AccountNumber, bold: true }];
      valueList = [
        this.soldToAccountdetails.AccountName + ' \n' +
        this.soldToAccountdetails.Address1 + ' \n' +
        (this.soldToAccountdetails.Address2 == '' ? '' : this.soldToAccountdetails.Address2 + ' \n') +
        this.soldToAccountdetails.AccountCity + ', ' + this.soldToAccountdetails.AccountState + ' ' + this.soldToAccountdetails.AccountZipCode + ' \n',

        this.pdfDataObject.accountName + ' \n' +
        this.pdfDataObject.accountAddress1 + ' \n' +
        this.pdfDataObject.accountCity + ', ' + this.pdfDataObject.accountState + ' ' + this.pdfDataObject.accountZipCode,

        this.deliverToAccountdetails.AccountName + ' \n' +
        this.deliverToAccountdetails.Address1 + ' \n' +
        this.deliverToAccountdetails.AccountCity + ', ' + this.deliverToAccountdetails.AccountState + ' ' + this.deliverToAccountdetails.AccountZipCode + ' \n',

      ];
    }

    if (this.isBulkItemAvailable) {
      bulkdetailsheader = {
        body: [
          ['ORDER NUMBER:', this.pdfDataObject.webOrderNumber.toString(),],
          ['CREATED:', this.datePipe.transform(this.pdfDataObject.createdOn, 'MM/dd/yyyy')],
          ['PLACED BY:', this.pdfDataObject.placedByName],
          ['CUSTOMER PO#:', this.pdfDataObject.custPONumber],
          ['BULK CONTACT NAME:', this.pdfDataObject.bulkContactName],
          ['BULK CONTACT PHONE NUMBER:', this.pdfDataObject.bulkContactNumber]
        ]
      };
    }
    else {
      bulkdetailsheader = {
        body: [
          ['ORDER NUMBER:', this.pdfDataObject.webOrderNumber.toString(),],
          ['CREATED:', this.datePipe.transform(this.pdfDataObject.createdOn, 'MM/dd/yyyy')],
          ['PLACED BY:', this.pdfDataObject.placedByName],
          ['CUSTOMER PO#:', this.pdfDataObject.custPONumber]
        ]
      };
    }

    if (this.isPackagedItemAvailable) {
      if (this.pdfDataObject.packagedContactName) bulkdetailsheader.body.push(['CONTACT NAME:', this.pdfDataObject.packagedContactName]);
      if (this.pdfDataObject.packagedContactNumber) bulkdetailsheader.body.push(['CONTACT PHONE NUMBER:', this.pdfDataObject.packagedContactNumber]);
      if (this.pdfDataObject.packagedDeliveryInst) bulkdetailsheader.body.push(['DELIVERY INSTRUCTIONS:', this.pdfDataObject.packagedDeliveryInst]);
    }

    this.isBulkItemAvailable = false;

    const pdfHTML = {
      footer: function (currentPage, pageCount, pageSize) {
        return [
          { text: currDate, alignment: 'left', fontSize: 8, style: 'pageText', marginLeft: 45 },
          { text: 'Page' + currentPage.toString() + ' of ' + pageCount, alignment: 'right', style: 'pageText', fontSize: 8, marginRight: 45 },
        ];
      },
      content: [
        {
          image: 'data:image/png;base64,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',
          width: 102,
          height: 37,
          alignment: 'left',
        },
        {
          layout: 'noBorders',
          table: bulkdetailsheader,
          style: 'pageText',
          fontSize: 8,
          marginTop: 10
        },
        {
          table: {
            widths: displayWith,
            headerRows: 1,
            fontSize: 5,
            body: [
              columnList,
              valueList,
            ]
          },
          marginTop: 10,
          fontSize: 8,
          style: 'pageText',
          layout: 'noBorders',
        },
        {
          alignment: 'center',
          table: {
            body: [
              [this.disclaimerMessage],
            ]
          },
          layout: 'noBorders',
          fontSize: 8,
          color: '#6fc8c0',
          margin: [40, 5, 40, 0]
        },
        {
          alignment: 'center',
          table: {
            body: [
              [this.dynamicDisclaimerMessage],
            ]
          },
          layout: 'noBorders',
          fontSize: 8,
          color: '#6fc8c0',
          widths: ['*'],
          margin: [40, 0, 40, 0]
        },
        this.getContractPdfObject(this.pdfDataObject.splitDetails),
        {
          style: 'tablefont',
          table: {
            body: [
              ['\nThis order was committed by ' + this.pdfDataObject.placedByName + ' on ' + orderCreateDate
                + ' (CST). If you have any questions regarding these changes, please contact WinField United Customer Service, 1-855-494-6343.'],
            ]
          },
          layout: 'noBorders'
        },
      ],
      styles: {
        pageText: {
          color: '#0b3f54',
        },
        header: {
          fontSize: 18,
          bold: true,
          margin: [0, 20, 0, 10],
          decoration: 'underline'
        },
        name: {
          fontSize: 16,
          bold: true
        },
        jobTitle: {
          fontSize: 14,
          bold: true,
          italics: true
        },
        sign: {
          margin: [0, 50, 0, 10],
          alignment: 'right',
          italics: true
        },
        tableHeader: {
          bold: true,
          fillColor: '#f5f4f2',
          fontSize: 8,
          color: '#0b3f54',
        },
        tablefont: {
          fontSize: 8,
          color: '#0b3f54'
        },
        tableUnit: {
          fontSize: 8,
          background: '#FDCF35',
          color: '#0b3f54'
        },
        tablePayment: {
          fontSize: 8,
          background: '#6fc8c0',
          color: '#0b3f54'
        }
      }
    };

    return pdfHTML;
  }

  // Grid display for each split in PDF
  getContractPdfObject(splitDetails) {
    const tblObject = [];
    splitDetails.forEach(obj => {
      let jdeNumber = '';
      if (obj.jdeorderNumber) {
        jdeNumber = obj.jdeorderNumber;
      }
      const cppOrderDetails = obj.productDetail;
      const desDelDate = (obj.productDetail[0].desiredDeliveryDate == null || obj.productDetail[0].desiredDeliveryDate == undefined) ? '' : obj.productDetail[0].desiredDeliveryDate;
      const desiredDeliveryDate = (desDelDate === '' ? '' : this.datePipe.transform(desDelDate.toString(), 'MM/dd/yyyy'));
      if (jdeNumber != '') {
        var tblHeader = [
          {
            style: 'pageText',
            widths: ['20%', '20%', '10%', '50%'],
            marginTop: 10,
            fontSize: 8,
            bold: true,
            columns: [{
              text: 'Order ID: ' + this.pdfDataObject.webOrderNumber.toString() + '-' + obj.splitId.toString(),
              alignment: 'left',
            },
            {
              text: 'Sales Order #: ' + jdeNumber,
              alignment: 'left',
            },
            {
              text: 'Status: ' + obj.orderStatus.toString(),
              alignment: 'left',
            },
            {
              text: 'Requested Arrival Date: ' + desiredDeliveryDate,
              alignment: 'right',
            }]
          }
        ];

        tblObject.push(tblHeader);
      }
      else {
        var tblHeader = [
          {
            style: 'pageText',
            widths: ['25%', '25%', '50%'],
            marginTop: 10,
            fontSize: 8,
            bold: true,
            columns: [{
              text: 'Order ID: ' + this.pdfDataObject.webOrderNumber.toString() + '-' + obj.splitId.toString(),
              alignment: 'left',
            },
            {
              text: 'Status: ' + obj.orderStatus.toString(),
              alignment: 'left',
            },
            {
              text: 'Requested Arrival Date: ' + desiredDeliveryDate,
              alignment: 'right',
            }]
          }
        ];

        tblObject.push(tblHeader);
      }

      const tbl = {
        table: {
          widths: ['30%', '15%', '15%', '25%', '15%'], // , '10%', '10%', '10%', '15%'
          color: '#0b3f54',
          body: [
            [{
              text: 'Product',
              style: 'tableHeader'
            },
            {
              text: 'Ordered Quantity',
              style: 'tableHeader', alignment: 'center'
            },
            {
              text: 'Ordering UOM',
              style: 'tableHeader', alignment: 'center'
            },
            {
              text: 'Package Size',
              style: 'tableHeader', alignment: 'center'
            },
            {
              text: 'Total',
              style: 'tableHeader', alignment: 'center'
            }],
            ...cppOrderDetails.map(cpp => {
              var cellData = [],
                cellData = this.cppModifiedCellData(cpp);
              return [
                { text: cellData },
                { text: cpp.lineStatus == 'CANCELLED' ? 'Cancelled' : cpp.originalOrderQuantity.toFixed(this.commonService.countDecimals(cpp.originalOrderQuantity)), alignment: 'center' },
                { text: cpp.uom, alignment: 'center' },
                { text: cpp.packageSize, alignment: 'center' },
                { text: cpp.totalGallons, alignment: 'center' }];
            })
          ]
        },
        style: 'tablefont',
      };
      tblObject.push(tbl);
    });

    return tblObject;
  }

  // For your price and payment Term in the cell with style
  cppModifiedCellData(cpp) {
    const tempArray = [];
    if (cpp.itemVendorName) {
      tempArray.push(cpp.itemVendorName + ' \n' + cpp.itemDescription + '\n');
    }
    else {
      tempArray.push('' + cpp.itemDescription + '\n');
    }
    if (cpp.yourPrice != null && cpp.yourPrice != '' && cpp.yourPrice != undefined && cpp.yourPrice != 0) {
      tempArray.push({
        text: ('$' + cpp.yourPrice.toFixed(4) + '/' + cpp.pricingUOM + '\n'), style: 'tableUnit'
      });
    }
    if (cpp.paymentTerms != null && cpp.paymentTerms != '' && cpp.paymentTerms != undefined) {
      tempArray.push({
        text: (cpp.paymentTerms.trim()), style: 'tablePayment'
      });
    }

    return tempArray;
  }

  // Clear selected filter
  clearFilter(filterValue) {
    const index = this.filterValueList.indexOf(filterValue);
    if (index > -1) {
      this.filterValueList.splice(index, 1);
      // remove product filter
      this.removeSelectedFilter(filterValue);

      if (this.filterValueList.length < 1) {
        this.getSearchData();
      }
      this.setAccSummaryTableHeight();
    }
  }

  applyDefaultFilter() {
    if (this.productFilters.Status == null || this.productFilters.Status.length === 0) {
      let openStatus = this.statusList.filter(x => x.id === 'O')[0];
      this.filter.status = openStatus.id + ',';
      this.openFilter.status = openStatus.id + ',';
      this.productFilters.Status = new Array();
      this.productFilters.Status.push(openStatus.value);
      this.productOpenFilters.Status = new Array();
      this.productOpenFilters.Status.push(openStatus.value);
      this.filterValueList.push('Status : ' + openStatus.value);
      this.openFilterValueList.push('Status : ' + openStatus.value);
    }
    if (this.productFilters.CropYear == null || this.productFilters.CropYear.length === 0) {
      let cropYear = this.cropYearList.filter(x => x.data === true)[0];
      this.filter.cropYear = cropYear.id + ',';
      this.openFilter.cropYear = cropYear.id + ',';
      this.productFilters.CropYear = new Array();
      this.productFilters.CropYear.push(cropYear.value);
      this.productOpenFilters.CropYear = new Array();
      this.productOpenFilters.CropYear.push(cropYear.value);
      this.filterValueList.push('Crop Year : ' + cropYear.value);
      this.openFilterValueList.push('Crop Year : ' + cropYear.value);
    }
  }

  validateNumText(numInput) {
    const accountRegx = RegExp('^[0-9, ]+$');
    const isValidNumInput = accountRegx.test(numInput);
    if (!isValidNumInput) {
      this.toastrService.error('Invalid Input.');
      numInput = null;
    }
    return numInput;
  }
  // Validate the search input text
  validateInputText() {
    if (this.productFilters.TxtAccountNo) {
      this.productFilters.TxtAccountNo = this.validateNumText(this.productFilters.TxtAccountNo);
    }
    if (this.productFilters.RequestID) {
      this.productFilters.RequestID = this.validateNumText(this.productFilters.RequestID);
    }
  }

  // Retain Filter Value
  retainFilter(selectedObj: any, type: string) {
    this.validateInputText();
    if (this.filterValueList) {
      this.setAccSummaryTableHeight();
      let selectedIds = '';
      if (selectedObj && selectedObj.selectedValues) {
        const selectedValues = selectedObj.selectedValues as any[];
        if (type == 'ItemNumber') {
          selectedValues.forEach(x => { selectedIds = selectedIds + x.value + ','; });
        } else if (type == 'Status' || type == 'CropYear') {
          selectedValues.forEach(x => { selectedIds = selectedIds + x.id + ','; });
        }
        else {
          selectedValues.forEach(x => { selectedIds = selectedIds + (type == 'AccountNo' ? x.accountNumber : x.id) + ','; });
        }
      }

      switch (type) {
        case 'ItemNumber':
          this.filter.itemNumber = selectedIds;
          break;
        case 'Status':
          this.filter.status = selectedIds;
          break;
        case 'CropYear':
          this.filter.cropYear = selectedIds;
          break;
      }
      // Create filterValueList from Product Filters
      this.filterValueList = [];
      if (this.productFilters) {
        if (this.productFilters.ProductName && this.productFilters.ProductName != '') {
          this.filterValueList.push('Product Name : ' + this.productFilters.ProductName);
          this.filter.productName = this.productFilters.ProductName.trim();
        }
        else {
          this.filter.productName = null;
        }

        if (this.productFilters.CustomerPO && this.productFilters.CustomerPO != '') {
          this.filterValueList.push('Customer PO : ' + this.productFilters.CustomerPO);
          this.filter.customerPO = this.productFilters.CustomerPO.trim();
        } else {
          this.filter.customerPO = null;
        }

        // Set Item No
        if (this.productFilters.ItemNumber && this.productFilters.ItemNumber.length > 0) {
          var strIno = '';
          this.productFilters.ItemNumber.forEach(x => {
            strIno = strIno + x + ', ';
          });
          this.filterValueList.push('Item Number : ' + strIno.substr(0, strIno.length - 2));
        }
        // Set Status
        if (this.productFilters.Status && this.productFilters.Status.length > 0) {
          var strIno = '';
          this.productFilters.Status.forEach(x => {
            strIno = strIno + x + ', ';
          });
          this.filterValueList.push('Status : ' + strIno.substr(0, strIno.length - 2));
        }
        if (this.productFilters.CropYear && this.productFilters.CropYear.length > 0) {
          var strIno = '';
          this.productFilters.CropYear.forEach(x => {
            strIno = strIno + x + ', ';
          });
          this.filterValueList.push('Crop Year : ' + strIno.substr(0, strIno.length - 2));
        }
        // text Account No
        if (this.productFilters.TxtAccountNo && this.productFilters.TxtAccountNo != '') {
          this.filterValueList.push('Account Number : ' + this.productFilters.TxtAccountNo);
          this.filter.accountNumber = this.productFilters.TxtAccountNo.trim();
        }
        else {
          this.filter.accountNumber = null;
        }

        // Account Name
        if (this.productFilters.AccountName && this.productFilters.AccountName != '') {
          this.filterValueList.push('Account Name : ' + this.productFilters.AccountName);
          this.filter.accountName = this.productFilters.AccountName.trim();
        }
        else {
          this.filter.accountName = null;
        }

        // Request ID
        if (this.productFilters.RequestID && this.productFilters.RequestID != '') {
          this.filterValueList.push('Request ID : ' + this.productFilters.RequestID);
          this.filter.requestID = this.productFilters.RequestID.trim();
        } else {
          this.filter.requestID = null;
        }
        // Web Order Number
        if (this.productFilters.WebOrderNumber && this.productFilters.WebOrderNumber != '') {
          this.filterValueList.push('Order ID : ' + this.productFilters.WebOrderNumber);
          this.filter.webOrderNumber = this.productFilters.WebOrderNumber.trim();
        } else {
          this.filter.webOrderNumber = null;
        }
      }
      this.setAccSummaryTableHeight();
    }
  }

  // To remove/clear selected chip search filter
  removeSelectedFilter(filterValue) {
    const removeFilter = filterValue.split(' : ');
    const index = -1;
    switch (removeFilter[0].trim()) {
      case 'Item Number':
        this.productFilters.ItemNumber = null;
        this.filter.itemNumber = null;
        break;
      case 'Product Name':
        this.productFilters.ProductName = null;
        this.filter.productName = null;
        break;
      case 'Customer PO':
        this.productFilters.CustomerPO = null;
        this.filter.customerPO = null;
        break;
      case 'Account Number':
        this.productFilters.TxtAccountNo = null;
        this.filter.accountNumber = null;
        break;
      case 'Account Name':
        this.productFilters.AccountName = null;
        this.filter.accountName = null;
        break;
      case 'Request ID':
        this.productFilters.RequestID = null;
        this.filter.requestID = null;
        break;
      case 'Status':
        this.productFilters.Status = null;
        this.filter.status = null;
        break;
      case 'Crop Year':
        this.productFilters.CropYear = null;
        this.filter.cropYear = null;
        break;
      case 'Order ID':
        this.productFilters.WebOrderNumber = null;
        this.filter.webOrderNumber = null;
        break;

      default:
        break;
    }
  }

  // Clear all filter
  clearAllFilter(isFirstLoad: Boolean) {
    this.filterValueList = new Array();
    this.resetPageFilter(isFirstLoad);
    if (!isFirstLoad) {
      this.getSearchData();
    }
    this.setAccSummaryTableHeight();
  }

  getSearchData() {
    if (this.selectedTabIndex === 0) {
      this.getSRAOrderRequestList();
    } else {
      this.getSraPlacedOrderList();
    }
  }
  checkPlaceOrderStatus() {
    const filter = {
      'productName': null,
      'itemNumber': null,
      'accountName': null,
      'accountNumber': null,
      'requestID': null,
      'status': null,
      'cropYear': null,
      'customerPO': null,
      'webOrderNumber': null
    };
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.sraOrdersService.getSraPlacedOrdersList(filter).subscribe((result: any[]) => {
      if (result.length <= 0) {
        this.isShowPlaceOrderTab = false;
      }
      this.loaderService.setLoaderStatus(false);
    }, error => { this.loaderService.setLoaderStatus(false); }));
  }

  getSRAOrderRequestList() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.sraOrdersService.getSraOrdersList(this.filter).subscribe((result: any[]) => {
      this.openRequestList = result;
      this.openRequestDataSource = new MatTableDataSource(this.openRequestList);
      this.openRequestDataSource.paginator = this.openRequestPaginator;
      this.openRequestDataSource.paginator.firstPage();
      this.openRequestDataSource.sortingDataAccessor = (item, property) => {
        switch (property) {
          case 'returnRequestID':
            return item.requestID;
          case 'shipToAccount':
            return item.shipToAccountName?.toLowerCase() || '';
          case 'deliverToAccount':
            return item.deliverToAccountName?.toLowerCase() || '';
          default:
            return item[property];
        }
      };
      this.openRequestDataSource.sort = this.openRequestSort;

      this.loaderService.setLoaderStatus(false);
    }, error => { this.loaderService.setLoaderStatus(false); }));
  }

  getSraPlacedOrderList() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.sraOrdersService.getSraPlacedOrdersList(this.filter).subscribe((result: any[]) => {
      const resultant = [];
      result.reduce(function (res, value) {
        if (!res[value.webOrderNumber]) {
          res[value.webOrderNumber] = { ...value }; // TO CLONE
          res[value.webOrderNumber].StatusList = [];
          resultant.push(res[value.webOrderNumber]);
          const outputResult = result.filter(x => x.webOrderNumber === value.webOrderNumber && x.successfullyProcessed != 'D');
          if (outputResult.filter(e => e.successfullyProcessed === 'E' || e.successfullyProcessed === 'B' || e.successfullyProcessed === 'F' || (e.status == 'ERROR')).length > 0) {
            value.status = 'ERROR';
          }
        }
        res[value.webOrderNumber].StatusList.push(value.status);
        return res;
      }, {});

      this.placedRequestDataSource = new MatTableDataSource(resultant);
      this.placedRequestDataSource.paginator = this.placedRequestPaginator;
      this.placedRequestDataSource.sort = this.placedRequestSort;

      this.loaderService.setLoaderStatus(false);
    }, error => { this.loaderService.setLoaderStatus(false); }));
  }


  // Navigate to selected order detail
  navigateOrderDetail(obj: any, tabType: string) {
    let isEditAccess = obj.status == "O" && this.hasRequestAccesse && this.hasSraEditAccess;
    this.sraOrdersService.setSroRequestId(+obj.requestID, isEditAccess);
    this.saveFilters();
    this.router.navigate(['/cpp/orders/sra-create-order']);
  }

  navigateToReviewApprove(action: boolean) {
    this.saveFilters();
    this.sraOrdersService.setIsApproveRequest(action);
    this.router.navigate(['/cpp/orders/sra-orders-approve-review']);
  }



  saveFilters() {
    if (this.selectedTabIndex == 0) {
      this.localStorageService.set('productOpenFilters', JSON.stringify(this.productFilters));
      this.localStorageService.set('openFilter', JSON.stringify(this.filter));
      this.localStorageService.set('openFilterValueList', JSON.stringify(this.filterValueList));
      this.localStorageService.set('openSelectedValue', JSON.stringify(this.selectedValue));

      this.localStorageService.set('productPlaceFilters', JSON.stringify(this.productPlaceFilters));
      this.localStorageService.set('placeFilter', JSON.stringify(this.placeFilter));
      this.localStorageService.set('placeSelectedValue', JSON.stringify(this.placeSelectedValue));
      this.localStorageService.set('placeFilterValueList', JSON.stringify(this.placeFilterValueList));
    } else {
      this.localStorageService.set('productPlaceFilters', JSON.stringify(this.productFilters));
      this.localStorageService.set('placeFilter', JSON.stringify(this.filter));
      this.localStorageService.set('placeFilterValueList', JSON.stringify(this.filterValueList));
      this.localStorageService.set('placeSelectedValue', JSON.stringify(this.selectedValue));

      this.localStorageService.set('productOpenFilters', JSON.stringify(this.productOpenFilters));
      this.localStorageService.set('openFilter', JSON.stringify(this.openFilter));
      this.localStorageService.set('openFilterValueList', JSON.stringify(this.openFilterValueList));
      this.localStorageService.set('openSelectedValue', JSON.stringify(this.openSelectedValue));
    }

  }


  // Delete open request
  deleteOrder(requestId) {
      const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '400px',
        data: { title: 'Delete Request', message: 'Do you want to delete this request?', labelYes: 'Yes', labelNo: 'No', dialogType: 'confirm' }
      });

      this.subscription.add(dialogRef.afterClosed().subscribe(result => {
        // If user selected Yes
        if (result == true) {
          this.loaderService.setLoaderStatus(true);
          this.subscription.add(this.sraOrdersService.deleteSraOrder(requestId).subscribe((result: any) => {
            if (result) {
              this.openRequestList = this.openRequestList.filter(x => x.requestID != requestId);
              this.openRequestDataSource = new MatTableDataSource(this.openRequestList);
              this.openRequestDataSource.paginator = this.openRequestPaginator;
              this.openRequestDataSource.paginator.firstPage();
                this.openRequestDataSource.sortingDataAccessor = (item, property) => {
                    switch (property) {
                        case 'returnRequestID':
                            return item.requestID;
                        case 'shipToAccount':
                            return item.shipToAccountName?.toLowerCase() || '';
                        case 'deliverToAccount':
                            return item.deliverToAccountName?.toLowerCase() || '';
                        default:
                            return item[property];
                    }
                };
                this.openRequestDataSource.sort = this.openRequestSort;
              this.loaderService.setLoaderStatus(false);
              this.toastrService.success('Successfully deleted.');
            } else {
              this.loaderService.setLoaderStatus(false);
              this.toastrService.error('There is some issue while delete.');
            }
          }, error => { this.loaderService.setLoaderStatus(false); }));
        }
      }));
  }

  public getStatusText(status: string): string {
    if (status.toUpperCase() === 'C') {
      return 'COMPLETED';
    }
    else {
      return 'OPEN';
    }
  }

  getRequestAccess() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.sraOrdersService.getSRARequestAccess().subscribe((result: any) => {
      this.hasRequestAccesse = result.hasNewEntryAccess;
      //this.hasReviewAccess = result.hasReviewAccess;
      this.hasReviewApproveAccess = result.hasReviewApproveAccess;
      if (!this.hasReviewApproveAccess) {
        this.hasReviewAccess = true;
      }
      this.loaderService.setLoaderStatus(false);
    }, error => {
      this.loaderService.setLoaderStatus(false);
    }));
  }

  // set account table height
  setAccSummaryTableHeight() {
    setTimeout(function () {
      const templateHeight = window.innerHeight - $('.TopSec').outerHeight() - $('.form-sec').outerHeight() - $('.mat-mdc-tab-header').outerHeight() - $('.fulfill-top-sec').outerHeight() - 150;
      $('.activeReturnRequest').css('max-height', templateHeight + 'px');
      $('.draftReturnRequest').css('max-height', templateHeight + 'px');
    }, 100);
  }

  createNewOrder() {
    this.sraOrdersService.setSroRequestId(0, true);
    this.saveFilters();
    this.router.navigate(['/cpp/orders/sra-create-order']);
  }

  // ngOnDestroy
  ngOnDestroy() {
    if (this.subscription) {
      this.commonService.currentTabIndex.next(0);
      this.subscription.unsubscribe();
    }
  }

}
